export const initialState = {
  loading: false,
  limits: {
    save_lists: null,
    save_search: null,
  },
};

export const limits = (state = initialState, action) => {
  switch (action.type) {
    case 'SAVE_LISTS':
      return {
        ...state,
        loading: true,
        limits: { save_lists: action.payload.limit_company },
      };
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};
